import {ContactSalesButton} from 'components/ContactSalesButton';
import {Trans} from 'gatsby-plugin-react-i18next';
import carpeta from 'images/carpeta.svg';
import coinstack from 'images/coinstack.svg';
import easy_payment_gateway from 'images/easy_payment_gateway.svg';
import megaphone from 'images/megaphone.svg';
import speechbubble from 'images/speechbubble.svg';
import React from 'react';
import styled from 'styled-components';
import {AnchorLink} from './AnchorLink';
import {Flex} from './Flex';
import Grid from './Grid';
import {InternalPageLink} from './links/Pages';

const ContactSalesStyled = styled(ContactSalesButton)`
  background: transparent;
  box-shadow: none;
  text-decoration: underline !important;
  color: #9d74b9;
  padding: 0;
  min-width: unset;
  height: unset;
  line-height: unset;
  font-weight: normal;
  transition: 250ms color;
  &:hover {
    background: transparent;
    box-shadow: none;
    transform: none;
    color: #8554a6;
  }
`;
export const LearnMoreLinks: React.FC = () => {
  return (
    <Grid columns={5} columnsXs={3} gap={48}>
      <Flex direction="column" justifyContent="flex-end" alignItems="center">
        <img src={coinstack} style={{width: 75}} alt="" />
        <Trans>
          <InternalPageLink slug="pricing">Pricing</InternalPageLink>
        </Trans>
      </Flex>
      <Flex direction="column" justifyContent="flex-end" alignItems="center">
        <img src={carpeta} style={{width: 65}} alt="" />
        <AnchorLink href="https://docs.monei.com">
          <Trans>Docs</Trans>
        </AnchorLink>
      </Flex>
      <Flex direction="column" justifyContent="flex-end" alignItems="center">
        <img src={easy_payment_gateway} style={{width: 75}} alt="" />
        <AnchorLink href="https://support.monei.com">
          <Trans>Support</Trans>
        </AnchorLink>
      </Flex>
      <Flex direction="column" justifyContent="flex-end" alignItems="center">
        <img src={megaphone} style={{width: 95, position: 'relative', top: '10px'}} alt="" />
        <Trans>
          <InternalPageLink slug="blog">Blog</InternalPageLink>
        </Trans>
      </Flex>
      <Flex direction="column" justifyContent="flex-end" alignItems="center">
        <img src={speechbubble} style={{width: 65}} alt="" />
        <ContactSalesStyled>
          <Trans>Contact</Trans>
        </ContactSalesStyled>
      </Flex>
    </Grid>
  );
};
